var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73541 13.6953H15.2604C15.4683 13.6953 15.6676 13.6127 15.8146 13.4658C15.9616 13.3188 16.0442 13.1194 16.0442 12.9116C16.0442 12.7037 15.9616 12.5044 15.8146 12.3574C15.6676 12.2104 15.4683 12.1278 15.2604 12.1278H2.73541C2.52755 12.1278 2.3282 12.2104 2.18122 12.3574C2.03423 12.5044 1.95166 12.7037 1.95166 12.9116C1.95166 13.1194 2.03423 13.3188 2.18122 13.4658C2.3282 13.6127 2.52755 13.6953 2.73541 13.6953ZM2.73541 9.78032H15.2604C15.4673 9.78032 15.6657 9.69814 15.812 9.55186C15.9582 9.40558 16.0404 9.20719 16.0404 9.00032C16.0404 8.79345 15.9582 8.59505 15.812 8.44878C15.6657 8.3025 15.4673 8.22032 15.2604 8.22032H2.73541C2.52854 8.22032 2.33015 8.3025 2.18387 8.44878C2.03759 8.59505 1.95541 8.79345 1.95541 9.00032C1.95541 9.20719 2.03759 9.40558 2.18387 9.55186C2.33015 9.69814 2.52854 9.78032 2.73541 9.78032ZM1.98541 5.08532C1.98541 5.28423 2.06443 5.475 2.20508 5.61565C2.34573 5.7563 2.5365 5.83532 2.73541 5.83532H15.2604C15.4683 5.83532 15.6676 5.75275 15.8146 5.60577C15.9616 5.45878 16.0442 5.25943 16.0442 5.05157C16.0442 4.84371 15.9616 4.64436 15.8146 4.49738C15.6676 4.35039 15.4683 4.26782 15.2604 4.26782H2.73541C2.62848 4.2631 2.52178 4.28131 2.42247 4.32125C2.32317 4.36118 2.23356 4.42191 2.15967 4.49935C2.08578 4.57679 2.02933 4.66915 1.99409 4.77022C1.95886 4.87129 1.94567 4.97873 1.95541 5.08532H1.98541Z",
    fill: "#E6E5E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.6eaa142b58aa9e29ac2f203e7dd6d717.svg";
export { ForwardRef as ReactComponent };